// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocUploadComponent } from './doc-upload/doc-upload.component';
import { DealUploadComponent } from './deal-upload/deal-upload.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { UploadDashboardComponent } from './upload-dashboard/upload-dashboard.component';
import { RouterModule } from '@angular/router';
import { DealerModule } from '../dealer/dealer.module';
import { InvalidUploadComponent } from './invalid-upload/invalid-upload.component';
import { IntellicheckTokenUploadComponent } from './doc-upload/intellicheck-upload/intellicheck-token-upload.component';

@NgModule({
    declarations: [UploadDashboardComponent, DocUploadComponent, DealUploadComponent, InvalidUploadComponent, IntellicheckTokenUploadComponent],
    imports: [CommonModule, DealerModule, MaterialModule, RouterModule, SharedModule],
})
export class UploadModule {}
